import WhySparksHeating from "../AboutUsPage/WhySparksHeating";
import OfferFinancing from "../FinancingServicesPage/OfferFinancing";
import Layout from "../Shared/Layout";
import FurnaceInstallation from "./FurnaceInstallation";
import FurnaceReplacementAbout from "./FurnaceReplacementAbout";
import './FurnaceReplacement.css';
import { Link, useNavigate, useParams } from "react-router-dom";
import { useCallback, useEffect, useState } from "react";
import { endpoints } from "../../_config";
import { get } from "../../_services/apiService";
import OverLay from "../HomePage/OverLay";

const ServiceDetail = () => {
    const serviceId = localStorage.getItem('serviceId');
    const navigate = useNavigate();
    const [productData, setProductData] = useState();
    const [error, setError] = useState(null);
    const [loading, setLoading] = useState(true);
    const params = useParams();


    const [showAppointmentSidebar, setShowAppointmentSidebar] = useState(false);
    const [activeTab, setActiveTab] = useState('book-appointment');

    const onContactUs = (activetab) => {
        setShowAppointmentSidebar(true);
        setActiveTab(activetab);
    }

    const GetProductDetailById = useCallback(async () => {
        try {
            const response = await get(endpoints.GetServiceDetailById + "?pServiceDetailId=" + serviceId)
            if (response.isSuccess === 200) {
                setProductData(response.data);
            } else {
                setError("Failed to fetch Product Data");
            }
        } catch (error) {
            setError("Please try again later.");
        } finally {
            setLoading(false);
        }

    }, [serviceId]);

    useEffect(() => {
        //  alert(serviceId);
        GetProductDetailById();
    }, [GetProductDetailById]);


    const onMenuchange = (serviceId) => {
        navigate('/our-product');
        localStorage.setItem('productcategoryId', serviceId)
    }


    return (
        <Layout>
            <OverLay
                    showAppointmentSidebar={showAppointmentSidebar}
                    activeTab={activeTab}
                    setActiveTab={setActiveTab}
                    setShowAppointmentSidebar={setShowAppointmentSidebar}
                />

            {productData?.map((item, i) => (
                <>
                    <div>
                        <section>
                            <div className="about_banner_wepper only_big_hedding_set">
                                <img src="images/about-banner.png" alt="" />
                                <div className="about_content">
                                    <h2>
                                        {item.headingName} </h2>
                                </div>
                            </div>
                        </section>
                    </div>

                    <div className="Furnace_wepper furnace_installation" style={{ padding: '85px 0' }}>
                        <div className="container">
                            <div className="about_hedding">
                                <h2>{item.headingName}</h2>
                                <p>{item.description}</p>
                                <div className="furnace_installation_inner_wepper">
                                    <Link className="same_btn" to="/get-quote-step"> Get a Quote <img src="images/right-arrow.svg" alt="" /></Link>
                                    {/* <Link className="same_btn" to="/get-quote-step"> Book Your Appointment <img src="images/right-arrow.svg" alt="" /></Link>
                                    <li className="book_appointment_click" onClick={() => onContactUs('book-appointment')}><img src="images/footer-arrow.svg" alt="" /> Book an
                                            Appointment</li> */}
                                    {item.productCategoryId != null ?
                                        <span className="same_btn" onClick={() => setShowAppointmentSidebar(true)}  >  Book Your Appointment  <img src="images/right-arrow.svg" alt="" /></span>
                                        : ""
                                    }
                                </div>
                            </div>
                            {item?.serviceFeatureDtos.length > 0 ? (
                                <div className="furnace_replacement_hedding">
                                    <div className="about_hedding mt-5">
                                        <h2>{item.featureHeader}</h2>
                                        <div className="row">
                                            <div className="col-lg-9">
                                                <ul className="Deeming_Frequent_wepper">
                                                    {item.serviceFeatureDtos.map((ele, j) => (
                                                        <li key={j}>
                                                            <strong>{ele.serviceTitle}</strong>
                                                            <p>{ele.serviceDescription}</p>
                                                        </li>
                                                    ))}
                                                </ul>
                                            </div>
                                            <div className="col-lg-3">
                                                <div className="Deeming_Frequent_img">
                                                    <img src="images/about.png" alt="About feature" />
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            ) : null}
                        </div>
                    </div>

                    {item.financeHeading ? (
                        <div className="financing_services_page">
                            <section className="same_space why_financing finance_hedding_wepper">
                                <div className="container">
                                    <div className="row">
                                        {/* Left Column: Content */}
                                        <div className="col-xxl-6 col-xl-6 col-lg-6 col-md-6 col-sm-12 col-12">
                                            <div className="about_hedding">
                                                <h5>Financing</h5>
                                                <h3>{item.financeHeading}</h3>
                                                <p>{item.financeDescription || "Learn more about our financing options tailored for you."}</p>
                                                <Link
                                                    to="/financing-services"
                                                    target="_blank"
                                                    className="same_btn"
                                                    aria-label="Learn more about financing services"
                                                >
                                                    Learn More <img src="images/right-arrow.svg" alt="Arrow pointing right" />
                                                </Link>
                                            </div>
                                        </div>
                                        {/* Right Column: Image */}
                                        <div className="col-xxl-6 col-xl-6 col-lg-6 col-md-6 col-sm-12 col-12">
                                            <div className="about_img_book">
                                                <img src="images/about.png" alt="Financing services illustration" />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </section>
                        </div>
                    ) : null}


                </>
            )
            )}
            {/* <OfferFinancing /> */}
            <div className="mt-5">
                <WhySparksHeating />
            </div>

        </Layout>
    )
}

export default ServiceDetail;